/*
 * This illustrates how to create a widget that makes use of a number of different field definition types.
 */

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps & HasProduct;
export interface ProductPriceInventoryQuantityAddButtonAreaStyles {
    gridItem?: InjectableCss;
    gridItemUom?: InjectableCss;
    gridContainer?:  InjectableCss;
}
export const productPriceInventoryQuantityAddButtonAreaStyles: ProductPriceInventoryQuantityAddButtonAreaStyles = {
    gridContainer: {
        css: css`
            border: 2px solid ${getColor("primary")};
            position: relative;
            padding: 10px;
            div[class^="GridOffset-"] {
                align-items: center;
                max-width: 100%;
            }
            > div[class^="GridOffset-"] {
                align-items: center;
                flex-wrap:nowrap;
                justify-content: space-between;
                gap: 10px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: flex;
                            flex-wrap:wrap;
                        `,
                        css`
                            display: flex;
                            flex-wrap:wrap;
                        `,
                        css`
                            display: flex;
                            flex-wrap:nowrap;
                        `,
                        css`
                            display: flex;
                            flex-wrap:nowrap;
                        `,
                    ],
                    "minMax",
                )}
            }
        `,
    },
    gridItem: {
        css: css`
        flex-direction: column;
        justify-content: end;
        flex-flow: nowrap;
        & > div:empty{
            border:none;
        }
        & [data-test-selector="product_qtyOrdered"] {
            height: 34px;
            white-space: nowrap;
            text-align: center;
            padding-right: 0 !important;
        }
        & [data-test-selector="addProductToCart"] {
            min-height: 36px;
            white-space: nowrap;
        }
        > div[class^="Wrapper-sc"] {
            text-align: center;
        }
        `,
    },
    gridItemUom: {
        css: css`
        flex-direction: row;
        justify-content: end;
        padding:2px;
        margin-left:8px!important;
        flex-flow: nowrap;
        & > div{
            border:1px solid;
            min-height:100%;
        }
        & > div:empty{
            border:none;
        }
        & > div > div > label{
            padding-left:10px;
            padding-top:10px;
            width: auto;
            min-width: 50px;
        }
        & > div > div{
            flex-direction: row;
            margin-top:0px!important;
        }
        & > div > div > div{
            margin-top:0px!important;
        }
        `,
    },
}
const styles = productPriceInventoryQuantityAddButtonAreaStyles;
const ProductPriceInventoryQuantityAddButtonArea: React.FC<Props> = ({ product, productInfo, id }) => {
    return (
        <GridContainer gap={0} {...styles.gridContainer}>
            <GridItem
                width={[12, 12, 6, 6, 6]}  {...styles.gridItem}
            >
                <Zone contentId={id} zoneName="PriceInventory"></Zone>
            </GridItem>
            <GridItem
                width={[12, 12, 6, 6, 6]}
                {...styles.gridItem}
            >
                <Zone contentId={id} zoneName="QtyAddBtn"></Zone>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductPriceInventoryQuantityAddButtonArea),
    definition: {
        displayName: "Price, Inventory, Quantity, + Add to Cart Container",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
